import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { URLBuilder } from "@azure/core-http";
import { BaseRequestPolicy } from "@azure/core-http";
import { delay } from "@azure/core-http";
/**
 * A set of constants used internally when processing requests.
 */

var Constants = {
  DefaultScope: "/.default",

  /**
   * Defines constants for use with HTTP headers.
   */
  HeaderConstants: {
    /**
     * The Authorization header.
     */
    AUTHORIZATION: "authorization"
  }
}; // Default options for the cycler if none are provided

var DEFAULT_CYCLER_OPTIONS = {
  forcedRefreshWindowInMs: 1000,
  retryIntervalInMs: 3000,
  refreshWindowInMs: 1000 * 60 * 2 // Start refreshing 2m before expiry

};
/**
 * Converts an an unreliable access token getter (which may resolve with null)
 * into an AccessTokenGetter by retrying the unreliable getter in a regular
 * interval.
 *
 * @param getAccessToken - a function that produces a promise of an access
 * token that may fail by returning null
 * @param retryIntervalInMs - the time (in milliseconds) to wait between retry
 * attempts
 * @param timeoutInMs - the timestamp after which the refresh attempt will fail,
 * throwing an exception
 * @returns - a promise that, if it resolves, will resolve with an access token
 */

function beginRefresh(_x, _x2, _x3) {
  return _beginRefresh.apply(this, arguments);
}
/**
 * Creates a token cycler from a credential, scopes, and optional settings.
 *
 * A token cycler represents a way to reliably retrieve a valid access token
 * from a TokenCredential. It will handle initializing the token, refreshing it
 * when it nears expiration, and synchronizes refresh attempts to avoid
 * concurrency hazards.
 *
 * @param credential - the underlying TokenCredential that provides the access
 * token
 * @param scopes - the scopes to request authorization for
 * @param tokenCyclerOptions - optionally override default settings for the cycler
 *
 * @returns - a function that reliably produces a valid access token
 */


function _beginRefresh() {
  _beginRefresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(getAccessToken, retryIntervalInMs, timeoutInMs) {
    var tryGetAccessToken, _tryGetAccessToken, token;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _tryGetAccessToken = function _tryGetAccessToken3() {
              _tryGetAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var finalToken;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(Date.now() < timeoutInMs)) {
                          _context3.next = 12;
                          break;
                        }

                        _context3.prev = 1;
                        _context3.next = 4;
                        return getAccessToken();

                      case 4:
                        return _context3.abrupt("return", _context3.sent);

                      case 7:
                        _context3.prev = 7;
                        _context3.t0 = _context3["catch"](1);
                        return _context3.abrupt("return", null);

                      case 10:
                        _context3.next = 18;
                        break;

                      case 12:
                        _context3.next = 14;
                        return getAccessToken();

                      case 14:
                        finalToken = _context3.sent;

                        if (!(finalToken === null)) {
                          _context3.next = 17;
                          break;
                        }

                        throw new Error("Failed to refresh access token.");

                      case 17:
                        return _context3.abrupt("return", finalToken);

                      case 18:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[1, 7]]);
              }));
              return _tryGetAccessToken.apply(this, arguments);
            };

            tryGetAccessToken = function _tryGetAccessToken2() {
              return _tryGetAccessToken.apply(this, arguments);
            };

            _context4.next = 4;
            return tryGetAccessToken();

          case 4:
            token = _context4.sent;

          case 5:
            if (!(token === null)) {
              _context4.next = 13;
              break;
            }

            _context4.next = 8;
            return delay(retryIntervalInMs);

          case 8:
            _context4.next = 10;
            return tryGetAccessToken();

          case 10:
            token = _context4.sent;
            _context4.next = 5;
            break;

          case 13:
            return _context4.abrupt("return", token);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _beginRefresh.apply(this, arguments);
}

function createTokenCycler(credential, scopes, tokenCyclerOptions) {
  var refreshWorker = null;
  var token = null;
  var options = Object.assign(Object.assign({}, DEFAULT_CYCLER_OPTIONS), tokenCyclerOptions);
  /**
   * This little holder defines several predicates that we use to construct
   * the rules of refreshing the token.
   */

  var cycler = {
    /**
     * Produces true if a refresh job is currently in progress.
     */
    get isRefreshing() {
      return refreshWorker !== null;
    },

    /**
     * Produces true if the cycler SHOULD refresh (we are within the refresh
     * window and not already refreshing)
     */
    get shouldRefresh() {
      var _a;

      return !cycler.isRefreshing && ((_a = token === null || token === void 0 ? void 0 : token.expiresOnTimestamp) !== null && _a !== void 0 ? _a : 0) - options.refreshWindowInMs < Date.now();
    },

    /**
     * Produces true if the cycler MUST refresh (null or nearly-expired
     * token).
     */
    get mustRefresh() {
      return token === null || token.expiresOnTimestamp - options.forcedRefreshWindowInMs < Date.now();
    }

  };
  /**
   * Starts a refresh job or returns the existing job if one is already
   * running.
   */

  function refresh(getTokenOptions) {
    var _a;

    if (!cycler.isRefreshing) {
      // We bind `scopes` here to avoid passing it around a lot
      var tryGetAccessToken = function tryGetAccessToken() {
        return credential.getToken(scopes, getTokenOptions);
      }; // Take advantage of promise chaining to insert an assignment to `token`
      // before the refresh can be considered done.


      refreshWorker = beginRefresh(tryGetAccessToken, options.retryIntervalInMs, // If we don't have a token, then we should timeout immediately
      (_a = token === null || token === void 0 ? void 0 : token.expiresOnTimestamp) !== null && _a !== void 0 ? _a : Date.now()).then(function (_token) {
        refreshWorker = null;
        token = _token;
        return token;
      }).catch(function (reason) {
        // We also should reset the refresher if we enter a failed state.  All
        // existing awaiters will throw, but subsequent requests will start a
        // new retry chain.
        refreshWorker = null;
        token = null;
        throw reason;
      });
    }

    return refreshWorker;
  }

  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tokenOptions) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!cycler.mustRefresh) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", refresh(tokenOptions));

            case 2:
              if (cycler.shouldRefresh) {
                refresh(tokenOptions);
              }

              return _context.abrupt("return", token);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x4) {
      return _ref.apply(this, arguments);
    };
  }();
}
/**
 * We will retrieve the challenge only if the response status code was 401,
 * and if the response contained the header "WWW-Authenticate" with a non-empty value.
 */


function getChallenge(response) {
  var challenge = response.headers.get("WWW-Authenticate");

  if (response.status === 401 && challenge) {
    return challenge;
  }

  return;
}
/**
 * Converts: `Bearer a="b" c="d"`.
 * Into: `[ { a: 'b', c: 'd' }]`.
 *
 * @internal
 */


function parseChallenge(challenge) {
  var bearerChallenge = challenge.slice("Bearer ".length);
  var challengeParts = "".concat(bearerChallenge.trim(), " ").split(" ").filter(function (x) {
    return x;
  });
  var keyValuePairs = challengeParts.map(function (keyValue) {
    return function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      return _defineProperty({}, key, value);
    }(keyValue.trim().split("="));
  }); // Key-value pairs to plain object:

  return keyValuePairs.reduce(function (a, b) {
    return Object.assign(Object.assign({}, a), b);
  }, {});
} // #endregion

/**
 * Creates a new factory for a RequestPolicy that applies a bearer token to
 * the requests' `Authorization` headers.
 *
 * @param credential - The TokenCredential implementation that can supply the bearer token.
 * @param scopes - The scopes for which the bearer token applies.
 */


export function storageBearerTokenChallengeAuthenticationPolicy(credential, scopes) {
  // This simple function encapsulates the entire process of reliably retrieving the token
  var getToken = createTokenCycler(credential, scopes);

  var StorageBearerTokenChallengeAuthenticationPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
    _inherits(StorageBearerTokenChallengeAuthenticationPolicy, _BaseRequestPolicy);

    var _super = _createSuper(StorageBearerTokenChallengeAuthenticationPolicy);

    function StorageBearerTokenChallengeAuthenticationPolicy(nextPolicy, options) {
      _classCallCheck(this, StorageBearerTokenChallengeAuthenticationPolicy);

      return _super.call(this, nextPolicy, options);
    }

    _createClass(StorageBearerTokenChallengeAuthenticationPolicy, [{
      key: "sendRequest",
      value: function () {
        var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(webResource) {
          var getTokenInternal, token, response, challenge, challengeInfo, challengeScopes, parsedAuthUri, pathSegments, tenantId, getTokenForChallenge, tokenForChallenge;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (webResource.url.toLowerCase().startsWith("https://")) {
                    _context2.next = 2;
                    break;
                  }

                  throw new Error("Bearer token authentication is not permitted for non-TLS protected (non-https) URLs.");

                case 2:
                  getTokenInternal = getToken;
                  _context2.next = 5;
                  return getTokenInternal({
                    abortSignal: webResource.abortSignal,
                    tracingOptions: {
                      tracingContext: webResource.tracingContext
                    }
                  });

                case 5:
                  token = _context2.sent.token;
                  webResource.headers.set(Constants.HeaderConstants.AUTHORIZATION, "Bearer ".concat(token));
                  _context2.next = 9;
                  return this._nextPolicy.sendRequest(webResource);

                case 9:
                  response = _context2.sent;

                  if (!((response === null || response === void 0 ? void 0 : response.status) === 401)) {
                    _context2.next = 25;
                    break;
                  }

                  challenge = getChallenge(response);

                  if (!challenge) {
                    _context2.next = 25;
                    break;
                  }

                  challengeInfo = parseChallenge(challenge);
                  challengeScopes = challengeInfo.resource_id + Constants.DefaultScope;
                  parsedAuthUri = URLBuilder.parse(challengeInfo.authorization_uri);
                  pathSegments = parsedAuthUri.getPath().split("/");
                  tenantId = pathSegments[1];
                  getTokenForChallenge = createTokenCycler(credential, challengeScopes);
                  _context2.next = 21;
                  return getTokenForChallenge({
                    abortSignal: webResource.abortSignal,
                    tracingOptions: {
                      tracingContext: webResource.tracingContext
                    },
                    tenantId: tenantId
                  });

                case 21:
                  tokenForChallenge = _context2.sent.token;
                  getToken = getTokenForChallenge;
                  webResource.headers.set(Constants.HeaderConstants.AUTHORIZATION, "Bearer ".concat(tokenForChallenge));
                  return _context2.abrupt("return", this._nextPolicy.sendRequest(webResource));

                case 25:
                  return _context2.abrupt("return", response);

                case 26:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function sendRequest(_x5) {
          return _sendRequest.apply(this, arguments);
        }

        return sendRequest;
      }()
    }]);

    return StorageBearerTokenChallengeAuthenticationPolicy;
  }(BaseRequestPolicy);

  return {
    create: function create(nextPolicy, options) {
      return new StorageBearerTokenChallengeAuthenticationPolicy(nextPolicy, options);
    }
  };
}